import PanchkarmaCommonAppointmentCalendar from "./PanchkarmaCoomanAppointmentCalender";
import PropTypes from "prop-types";
import { useEffect } from "react";

export const PanchkarmaServiceCallerAppointmentCalendar = ({
  leadId,
  patientId,
  doctorId,
}) => {
  const handleBookingSuccess = (appointmentData) => {
    console.log("Service Caller - Appointment booked:", appointmentData);
    // Handle booking success for service caller
  };

  const handleCancelSuccess = (appointmentId) => {
    console.log("Service Caller - Appointment cancelled:", appointmentId);
    // Handle cancel success for service caller
  };

  const handlePaymentSuccess = (paymentData) => {
    console.log("Service Caller - Payment collected:", paymentData);
    // Handle payment success for service caller
  };

  // Get current week's start and end dates
  const getCurrentWeekDates = () => {
    const now = new Date();
    const monday = new Date(now);
    monday.setDate(monday.getDate() - monday.getDay() + 1); // Get Monday
    monday.setHours(0, 0, 0, 0);

    const sunday = new Date(now);
    sunday.setDate(sunday.getDate() - sunday.getDay() + 7); // Get Sunday
    sunday.setHours(23, 59, 59, 999);

    return { start: monday, end: sunday };
  };

  // Initial load effect
  useEffect(() => {
    const { start, end } = getCurrentWeekDates();
    // The CommonAppointmentCalendar will handle the actual API call
    // We just need to ensure it has the correct initial dates
  }, []);

  return (
    <PanchkarmaCommonAppointmentCalendar
      leadId={leadId}
      patientId={patientId}
      doctorId={doctorId}
      currentLeadId={leadId}
      currentPatientId={patientId}
      module="service_caller"
      appointmentType="service_caller"
      onBookingSuccess={handleBookingSuccess}
      onCancelSuccess={handleCancelSuccess}
      onPaymentSuccess={handlePaymentSuccess}
      className="service-caller-calendar"
      initialStartDate={getCurrentWeekDates().start}
      initialEndDate={getCurrentWeekDates().end}
    />
  );
};

PanchkarmaServiceCallerAppointmentCalendar.propTypes = {
  leadId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  patientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  doctorId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
